var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 489.7 431.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #83b542;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "list",
    transform: "translate(0 -29.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    className: "cls-1",
    d: "M52.7,134.75A52.75,52.75,0,1,0,0,81.95,52.771,52.771,0,0,0,52.7,134.75Zm0-81a28.2,28.2,0,1,1-28.2,28.2A28.231,28.231,0,0,1,52.7,53.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    className: "cls-1",
    d: "M52.7,297.55A52.7,52.7,0,1,0,0,244.85,52.771,52.771,0,0,0,52.7,297.55Zm0-80.9a28.2,28.2,0,1,1-28.2,28.2A28.231,28.231,0,0,1,52.7,216.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    className: "cls-1",
    d: "M52.7,460.45A52.7,52.7,0,1,0,0,407.75,52.771,52.771,0,0,0,52.7,460.45Zm0-81a28.2,28.2,0,1,1-28.2,28.2A28.231,28.231,0,0,1,52.7,379.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    className: "cls-1",
    d: "M175.9,94.25H477.4a12.3,12.3,0,0,0,0-24.6H175.9a12.3,12.3,0,1,0,0,24.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    className: "cls-1",
    d: "M175.9,257.15H477.4a12.3,12.3,0,0,0,0-24.6H175.9a12.3,12.3,0,0,0,0,24.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    className: "cls-1",
    d: "M175.9,419.95H477.4a12.3,12.3,0,1,0,0-24.6H175.9a12.3,12.3,0,1,0,0,24.6Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.0e6b5940ca98944c41bd4b03aa279e87.svg";
export { ForwardRef as ReactComponent };